<div class="chart-content">
  <div class="chart-container">
    <div *ngIf="loading()" class="chart-loading">
      <div class="spinner"></div>
      <p>Loading chart data...</p>
    </div>

    <div *ngIf="error()" class="chart-error">
      <p>{{ error() }}</p>
    </div>

    <canvas *ngIf="!loading() && !error()" baseChart
      [data]="chartData()"
      [options]="chartOptions"
      type="line">
    </canvas>
  </div>
  <div class="totals">
    <div class="total-item">
      <span class="total-label">This Year:</span>
      <span class="total-this-year" [class.currency]="currencyFormat">
        {{ currencyFormat ? (thisYearTotal() | currency:'USD':'symbol':'1.0-0') : (thisYearTotal() | number) }}
      </span>
    </div>
    <div class="total-item">
      <span class="total-label">Last Year:</span>
      <span class="total-last-year" [class.currency]="currencyFormat">
        {{ currencyFormat ? (lastYearTotal() | currency:'USD':'symbol':'1.0-0') : (lastYearTotal() | number) }}
      </span>
    </div>
  </div>
</div> 